import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import DialogHeader from "../DialogHeader";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    alignItems: "center",
    backgroundColor: "#FCFCFD",
    borderRadius: 4,
    border: 0,
    boxShadow:
      "rgba(45, 35, 66, 0.4) 0 2px 4px,rgba(45, 35, 66, 0.3) 0 7px 13px -3px,#D6D6E7 0 -3px 0 inset",
    boxSizing: "border-box",
    color: "#36395A",
    cursor: "pointer",
    fontFamily: "JetBrains Mono, monospace",
    justifyContent: "center",
    lineHeight: "1.4",
    padding: "14px 16px",
    textAlign: "left",
    textDecoration: "none",
    transition: "all .2s ease",
    userSelect: "none",
    fontSize: "16px",
    fontWeight: 500,
    display: "block",
    width: "100%",
    "&:hover": {
      boxShadow:
        "rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset",
      transform: "translateY(-2px)",
      backgroundColor: "#F8F9FA",
    },
    "&:active": {
      boxShadow: "#D6D6E7 0 3px 7px inset",
      transform: "translateY(2px)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "12px 14px",
    },
  },
  buttonSelected: {
    alignItems: "center",
    backgroundImage:
      "radial-gradient(100% 100% at 100% 0, #5adaff 0, #5468ff 100%)",
    border: 0,
    borderRadius: 4,
    boxShadow:
      "rgba(45, 35, 66, .4) 0 2px 4px,rgba(45, 35, 66, .3) 0 7px 13px -3px,rgba(58, 65, 111, .5) 0 -3px 0 inset",
    boxSizing: "border-box",
    color: "white",
    cursor: "pointer",
    fontFamily: "JetBrains Mono, monospace",
    justifyContent: "center",
    lineHeight: "1.4",
    padding: "14px 16px",
    textAlign: "left",
    textDecoration: "none",
    transition: "all .2s ease",
    userSelect: "none",
    fontSize: "16px",
    fontWeight: 600,
    display: "block",
    width: "100%",
    "&:hover": {
      boxShadow:
        "rgba(45, 35, 66, .4) 0 4px 8px, rgba(45, 35, 66, .3) 0 7px 13px -3px, #3c4fe0 0 -3px 0 inset",
      transform: "translateY(-2px)",
    },
    "&:active": {
      boxShadow: "#3c4fe0 0 3px 7px inset",
      transform: "translateY(2px)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "12px 14px",
    },
  },
  videoContainer: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#000",
    marginTop: 16,
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: 0,
    borderRadius: 12,
  },
}));

const YoutubeVideoDialog = ({ open, handleCloseDialog, videoLink }) => {
  const [defaultVideoLink, setDefaultVideoLink] = useState(videoLink[0]?.link);
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minWidth: { xs: "95%", sm: "90%", md: "85%" },
          maxWidth: { xs: "95%", sm: "90%", md: "1200px" },
          m: { xs: 1, sm: 2 },
        },
      }}
    >
      <DialogTitle sx={{ p: "0 !important" }}>
        <DialogHeader
          handleClose={() => handleCloseDialog()}
          title="YouTube video"
        />
      </DialogTitle>

      <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} md={8}>
            <Box className={classes.videoContainer}>
              <iframe
                className={classes.iframe}
                src={defaultVideoLink}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack
              spacing={1.5}
              sx={{
                maxHeight: { xs: 300, md: 450 },
                overflow: "auto",
                p: { xs: 1, sm: 1.5 },
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#555",
                  },
                },
              }}
            >
              {videoLink?.map((item, index) => (
                <Typography
                  key={index}
                  title={item?.description}
                  component="button"
                  className={
                    defaultVideoLink === item.link
                      ? classes.buttonSelected
                      : classes.button
                  }
                  onClick={() => {
                    setDefaultVideoLink(item?.link);
                  }}
                >
                  {item?.title}
                </Typography>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default YoutubeVideoDialog;